import {ReportPeriod} from "../../../models/ReportPeriod";
import {IsoDate} from "../../../../../../pseudo-types/DateTypes";
import {Pair} from "../../../../../../types/GenericTypes";
import moment from "moment";
import {Moment} from "moment-timezone";
import {DateTimeUtil} from "../../../../../../js/util/DateTimeUtil";
import {
    currentFinancialYearToDate,
    monthToDate,
    previousFinancialYear,
    previousQuarter,
    quarterToDate,
    weekToDate,
    yearToDate
} from "../../../../../../js/util/TimeFrameUtil";

export function reportPeriod(period: ReportPeriod): Pair<IsoDate> {
    const today = moment();
    switch (period) {
        case ReportPeriod.DAY:
            return dayReportPeriod(today);
        case ReportPeriod.WEEK:
            return weekToDate(today);
        case ReportPeriod.MONTH:
            return monthToDate(today);
        case ReportPeriod.CURRENT_QUARTER:
            return quarterToDate(today);
        case ReportPeriod.PREVIOUS_QUARTER:
            return previousQuarter(today);
        case ReportPeriod.CURRENT_FINANCIAL_YEAR:
            return currentFinancialYearToDate(today);
        case ReportPeriod.PREVIOUS_FINANCIAL_YEAR:
            return previousFinancialYear(today);
        case ReportPeriod.YEAR_TO_DATE:
            return yearToDate(today);
        case ReportPeriod.CUSTOM:
            return dayReportPeriod(today);
    }
}

function dayReportPeriod(today: Moment): Pair<IsoDate> {
    const formatted = DateTimeUtil.momentToIsoDate(today);
    return [formatted, formatted];
}
